import { CarriersController } from "../controllers/carriers-controller";
import { Carrier } from "../models/carrier"
import { CarrierFilter } from "../models/carrier-filter"
import { BusyService } from "../services/busy-service";
import { WebApiService } from "../services/web-api-service";
import { AureliaCookie } from 'aurelia-cookie';

//import 'ag-grid-enterprise/main';
import { observable, computedFrom, autoinject } from "aurelia-framework";
import { singleton } from 'aurelia-framework';
import * as condition from './widgets/list-filter/condition';
import { Division } from "../models/division";
import { Contact } from "../models/contact";
import { DialogService } from "aurelia-dialog";
import { UpdateDivisionContactDialog } from "./dialogs/update-division-contact-dialog";
import { AppMessageService } from "../services/app-message-service";

@singleton()
@autoinject()
export class Divisions {

    constructor(
        private busyService: BusyService,
        private dialogService: DialogService,
        private carriersController: CarriersController,
        private appMessageService: AppMessageService,
        private api: WebApiService) {
    }

    async activate(params) {
        await this.initializePage(params.id);
    }

    async refresh() {
        const selectedDivisionId = (this.selectedDivision || { id: -1 }).id;
        this.initializePage(selectedDivisionId, true);
    }

    async initializePage(selectedDivisionId: number, forceReload: boolean = false) {
        if (forceReload || this.divisions.length == 0) {
            await this.loadDivisions();
        }
        if (selectedDivisionId) {
            this.selectedDivision = this.divisions.find((o: Division) => o.id == selectedDivisionId);
            if (this.selectedDivision) {
                await this.loadSelectedDivisionContacts(this.selectedDivision.id);
            }
        }
    }

    async loadSelectedDivisionContacts(divisionId: number) {
        this.busyService.on();
        try {
            var result = await this.api.get("Divisions", "GetDivisionContacts", { divisionId: divisionId });
            this.selectedDivisionContacts = JSON.parse(result.response);
        } finally {
            this.busyService.off();
        }
    }

    onReady() {
        this.autosizeColumns();
    }

    autosizeColumns() {
        this.gridOptions.api.columnController.autoSizeAllColumns();
    }

    openContactDialog(contact: Contact) {
        this.dialogService.open({
            viewModel: UpdateDivisionContactDialog,
            model: {
                contact: contact,   //create a copy so that the original isn't modified
                divisionId: this.selectedDivision.id
            }
        }).whenClosed((result) => {
            if (!result.wasCancelled) {
                //reload contacts
                this.loadSelectedDivisionContacts(this.selectedDivision.id);
            }
        });
    }

    columnDefs: Array<any> = [
        { field: "id", hide: true },
        {
            field: "name", headerName: "Name", filter: 'text',
            cellRenderer: (params) => this.linkCellRenderer(params)
        },
        {
            field: "code", headerName: "Mill Code", filter: 'text',
            cellRenderer: (params) => this.linkCellRenderer(params)
        },
        { field: "state", headerName: "State", filter: 'text' },
        { field: "city", headerName: "City", filter: 'text' }
    ];

    gridOptions = {
        api: null,  // this is set by the grid once initialized.
        columnDefs: this.columnDefs,
        pagination: false
    };

    selectedDivision: Division;
    selectedDivisionContacts: Array<Contact> = [];
    divisions: Array<any> = [];

    loadDivisions() {
        this.busyService.on();
        return this.api.get("Divisions", "GetDivisions")
            .then((result) => {
                this.divisions = JSON.parse(result.response);
            })
            .finally(() => {
                this.busyService.off();
            });
    }

    private linkCellRenderer(params: any) {
        if (params.value != null) {
            //Note: include the route-href parameter so that the addBaseUrlIfMiddleClick (in app.ts) 
            //          is processed(even though the href attribute is set directly)
            return `<a route-href href=\'/divisions/${params.api.getValue("id", params.node)}'>${params.value}</a>`;
        }
        return params.value;
    }

    saveDivision() {
        this.busyService.on();
        try {
            this.api.post("Divisions", "UpdateDivision", this.selectedDivision);
            this.appMessageService.addSuccessMessage("Division updated");
        } catch (e) {
            alert("Error saving division: " + e);
        } finally {
            this.busyService.off();
        }
    }

}